export default __webpack_public_path__ + "static/media/news4img2.9807fb24.png";